import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: "app-online-payment-confirmation",
  templateUrl: "./online-payment-confirmation.component.html",
  styleUrls: ["./online-payment-confirmation.component.css"],
})
export class OnlinePaymentConfirmationComponent implements OnInit {
  tellerForm: FormGroup;
  submitted = false;
  session_type: string;
  selected_session_type: string = "";
  sessionOptions: any[] = [
    { id: "physical", name: "IN PERSON" },
    { id: "online", name: "VIRTUAL" },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<OnlinePaymentConfirmationComponent>,
    private formBuilder: FormBuilder
  ) {
    this.tellerForm = this.formBuilder.group({
      accountType: [this.selected_session_type, Validators.required],
    });
  }

  ngOnInit() {
    // console.log('Session: ', this.data);
    this.session_type = this.data.session_type;
    console.log(`The session type inside offline payment ${this.session_type}`);
  }

  get f() {
    return this.tellerForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.tellerForm.invalid) {
      return;
    }

    this.selected_session_type = this.tellerForm.value.accountType;

    this.dialogRef.close({ data: this.selected_session_type });
  }

  checkSeletedType(event: string) {
    this.selected_session_type = event;
  }
}
